import React, { useRef } from 'react';
import {
  AdminLegendVariant,
  adminGetCompleteContract,
  IAdminBookedProfessional,
  IAdminCompleteContract,
  PharmacistLegendVariant,
} from '@pharmaplan/common';

import UserSelectionModal from '../../../components/UserSelectionModal';
import { showError } from '../../../components/Admin/Profile/Pharmacist/PharmacistViewProfile/helper';
import { renderScreen } from '../../../actions/drawerActions';
import { OtherScreens, ScreenTypes } from '../../../helpers/Constants';
import { resetDialog, setDialog } from '../../../reducers/dialogReducer';
import strings from '../../../localization';
import { useAppDispatch } from '../../useAppDispatch';
import useDrawer from '../../useDrawer';

const useEditMultiDayBooking = () => {
  const dispatch = useAppDispatch();
  const { openDrawer } = useDrawer();
  const isLoading = useRef(false);

  const openBooking = async (
    professionalId: string,
    longTermContractId: string,
    workshiftId: string,
  ) => {
    if (isLoading.current) return;
    isLoading.current = true;

    try {
      const result = await dispatch(adminGetCompleteContract({
        professionalId,
        longTermContractId,
        type: PharmacistLegendVariant.booked,
      }));
      if (!adminGetCompleteContract.fulfilled.match(result)) return;

      const contract: IAdminCompleteContract = result.payload;
      const bookingId = contract.data.find((booking) =>
        !!booking.bookingId)?.bookingId ?? null;

      if (!bookingId) {
        showError(dispatch, strings.noDataAvailable);
        return;
      }

      dispatch(resetDialog());
      openDrawer();
      dispatch(renderScreen({
        screenNumber: 5,
        screenType: ScreenTypes.availableWorkshift,
        eventId: bookingId,
        workshiftId,
        type: AdminLegendVariant.booked,
        fromScreen: OtherScreens.ListOfWorkshifts,
      }));
    } finally {
      isLoading.current = false;
    }
  };

  const showEditBookings = (
    longTermShiftContractId: string,
    workshiftId: string,
    bookedProfessionals: IAdminBookedProfessional[],
  ) => {
    dispatch(setDialog({
      heading: { title: '' },
      Component: (
        <UserSelectionModal
          bookedProfessionals={bookedProfessionals}
          title={strings.editBooking}
          message={strings.pleaseChooseReplacementToEditBooking}
          onProfessionalSelect={(professional) =>
            openBooking(professional.professionalId, longTermShiftContractId, workshiftId)}
        />
      ),
      showCloseButton: true,
    }));
  };

  return { showEditBookings };
};

export default useEditMultiDayBooking;
